import { RiskScoreDescriptionEnum, RiskScores } from '../../types';

export const formatRiskScoreName = (riskScore: RiskScores | null): string =>
  riskScore ? RiskScoreDescriptionEnum[riskScore] : 'Unknown';
